import { OrderedMap } from 'immutable';
import { DEAL_SPLIT_OBJECT_ID } from '../constants/CrmSearchConstants';
// If a deal was just created, it might have no deal splits populated yet.
// In this case, add a default deal split with 100% credit to the state.
const DEFAULT_DEAL_SPLIT = {
  objectId: 0,
  objectTypeId: DEAL_SPLIT_OBJECT_ID,
  state: {
    state: '',
    timestamp: 0
  },
  properties: {
    hs_deal_split_percentage: {
      value: '1'
    }
  },
  portalId: 0
};

// Converts a deal split from format provided by /search/deals/ endpoint
// into a flattened format to store in Redux
export const createDealSplitObject = dealSplit => {
  const {
    dealSplitId,
    portalId
  } = dealSplit;
  const {
    state,
    properties
  } = dealSplit.crmObject;
  return {
    objectId: dealSplitId,
    objectTypeId: DEAL_SPLIT_OBJECT_ID,
    state,
    properties,
    portalId
  };
};

// Converts a deal from format provided by /search/deals/ endpoint
// into a flattened format to store in Redux
export const createDealObject = deal => {
  const {
    auditHistory,
    dealAmount,
    dealId,
    dealSplit,
    dealSplits,
    portalId,
    weightedDealAmount
  } = deal;
  const {
    objectTypeId,
    objectId,
    properties,
    objectVersion,
    objectStates,
    reverseReferences,
    mergeAudits,
    secondaryIdentifier,
    currentUserPermissions,
    state
  } = deal.dealCrmObject;
  return {
    currentUserPermissions,
    dealAmount,
    dealId,
    dealSplit: dealSplit ? createDealSplitObject(dealSplit) : DEFAULT_DEAL_SPLIT,
    dealSplits: dealSplits.length > 0 ? dealSplits.map(split => createDealSplitObject(split)) : [DEFAULT_DEAL_SPLIT],
    history: auditHistory,
    portalId,
    mergeAudits,
    objectTypeId,
    objectId,
    objectVersion,
    objectStates,
    properties,
    reverseReferences,
    secondaryIdentifier,
    state,
    weightedDealAmount
  };
};

// TODO: Convert Deals state to a POJO instead of ImmutableMap
export const createDealObjects = deals => deals.reduce((acc, deal) => acc.set(deal.dealId, createDealObject(deal)), OrderedMap());